import { Fragment, useCallback, useEffect, useState, useContext } from "react";
import SwiperCore, { Pagination, Navigation, Autoplay, EffectFade } from "swiper";
import { SwiperSlide, Swiper } from "swiper/react";
import Slide from "../../components/slide";
import Info from "../../components/_info";
import { TestimonialSection } from "../../sections/testimonialSection";
import { WhyHJSection } from "../../sections/whyHJSection";
import { useTranslation } from "react-i18next";
import HomeOfferSection from "./sections/homeOfferSection";
import HomeVehicleSection from "./sections/homeVehicleSection";
import AdsBanner from "../../components/adsBanner";
import Skeleton from "react-loading-skeleton";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import MaintenanceContext from "../maintenance/maintenanceContext";
import * as vehicleService from "../../services/vehicleService";
import * as homeService from "../../services/homeService";
import { callFunc } from "../../services/funcService";
import ServicesSection from "./components/servicesSection";
import CounterSection from "../about/components/about-counter";
import axios from "axios";
import config from "../../configuration/config";
import "./home_v7.css";
import { HomeSearch } from "./components/homeSearch";
SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade]);


export function Home() {
  const { t: trans, i18n } = useTranslation(["common", "inputs", "offers", "home", "info"]);
  const { handleServiceOrder } = useContext(MaintenanceContext);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const [cars, setCars] = useState([]);
  const [brands, setBrands] = useState([]);
  const [offerPart, setOfferPart] = useState([]);
  const [offerPartFilters, setOfferPartFilters] = useState([]);
  const [offerVehicle, setOfferVehicle] = useState([]);
  const [offerVehicleFilters, setOfferVehicleFilters] = useState([]);
  const [slides, setSlides] = useState([]);
  const [hjInfo, setHjInfo] = useState(null);
  const lang = i18n.language || "ar";
  const [isLoadingslides, setLoadingslides] = useState(true);
  const [isLoadingInfo, setLoadingInfo] = useState(true);
  const [aboutData, setAboutData] = useState({});

  useEffect(() => {
    async function fetchAboutData() {
      try {
        const response = await axios.request({
          baseURL: config.controllURL,
          url: lang + "/api/About/index",
          method: "get",
        });
        setAboutData(response.data.about);
      } catch (error) {
        console.error(error);
      }
    }
    fetchAboutData();
  }, [lang]);

  useEffect(() => {
    var isServicepopup = query.get("servicepopup");

    if (isServicepopup) {
      handleServiceOrder({
        showPopup: true,
      });
    }
    callback();
  }, []);

  const callback = useCallback(async () => {
    // axios.defaults.timeout = 150000;

    var curentSlides;
    setLoadingslides(true);

    try {
      if ("caches" in window) {
        let url = "slides";

        // Opening that particular cache
        const cacheStorage = await caches.open("HJWeb");
        // Fetching that particular cache data
        const cachedResponse = await cacheStorage.match(url);
        let data = await cachedResponse?.json();
        if (Array.isArray(data)) {
          setSlides(data);
          curentSlides = data;
          setLoadingslides(false);
        }
      }
    } catch (error) { }
    // axios.request({
    //     baseURL: config.controllURL,
    //     url: lang + "/api/home/slides",
    //     method: "get",
    // })
    // Backend returns slide fields in PascalCase (Type/Brand/BrandID/Year/Name/
    // ColorID/SeatsNumber/MinPrice/HP/Cylinders/Petrol/SiteId/Group/Slug/…).
    // UI reads them camelCase — normalize here so the hero carousel populates.
    const normalizeSlide = (s) => s && ({
      ...s,
      siteId: s.siteId ?? s.SiteId,
      type: s.type ?? s.Type,
      seatsNumber: s.seatsNumber ?? s.SeatsNumber,
      year: s.year ?? s.Year,
      hybridImage: s.hybridImage ?? s.HybridImage,
      image: s.image ?? s.Image,
      background: s.background ?? s.Background,
      name: s.name ?? s.Name,
      cylinders: s.cylinders ?? s.Cylinders,
      petrol: s.petrol ?? s.Petrol,
      colorID: s.colorID ?? s.ColorID,
      hp: s.hp ?? s.HP,
      brand: s.brand ?? s.Brand,
      brandID: s.brandID ?? s.BrandID,
      otherBrand: s.otherBrand ?? s.OtherBrand,
      group: s.group ?? s.Group,
      slug: s.slug ?? s.Slug,
      minPrice: s.minPrice ?? s.MinPrice,
      productId: s.productId ?? s.ProductId,
      rateCareDiscount: s.rateCareDiscount ?? s.RateCareDiscount,
      rateTaxCar: s.rateTaxCar ?? s.RateTaxCar,
      modelTypes: s.modelTypes ?? s.ModelTypes,
      end_at: s.end_at ?? s.End_at ?? s.EndAt,
      newCar_DateEnd: s.newCar_DateEnd ?? s.NewCar_DateEnd,
      newCar: s.newCar ?? s.NewCar,
      hybird: s.hybird ?? s.Hybird,
      showPric: s.showPric ?? s.ShowPric,
      viewSliderIcon: s.viewSliderIcon ?? s.ViewSliderIcon,
      viewSliderDetails: s.viewSliderDetails ?? s.ViewSliderDetails,
      viewBtns: s.viewBtns ?? s.ViewBtns,
      sliderBackOpasity: s.sliderBackOpasity ?? s.SliderBackOpasity,
    });

    homeService
      .fetchHomeSlides()
      .then((response) => {
        const normalized = (response.data.slides || []).map(normalizeSlide);
        setSlides(normalized);
        curentSlides = normalized;
        setLoadingslides(false);
        const data = new Response(JSON.stringify(curentSlides));

        if ("caches" in window) {
          // Opening given cache and putting our data into it
          caches.open("HJWeb").then((cache) => {
            cache.put("slides", data);
          });
        }
      })
      .catch((error) => {
        setLoadingslides(false);
      });

    let curentInfo;
    try {
      setLoadingInfo(true);
      try {
        if ("caches" in window) {
          let url = "siteHomePage";

          // Opening that particular cache
          const cacheStorage = await caches.open("HJWeb");
          console.log("vcacheStorage", cacheStorage);
          // Fetching that particular cache data
          const cachedResponse = await cacheStorage.match(url);
          let data = await cachedResponse?.json();
          console.log("data", data);
          curentInfo = {
            title: data[`Title`],
            description: data[`Description`],
            image: data.Image,
          };

          setHjInfo({ ...curentInfo });
          setLoadingInfo(false);
        }
      } catch (error) { }

      // axios.request({
      //     baseURL: config.controllURL,
      //     url: lang + "/api/home/HomeInfo",
      //     method: "get",
      // })
      homeService
        .fetchHomeInfo()
        .then((response) => {
          setLoadingInfo(false);
          const responseData = response.data;
          if (responseData.length > 0) {
            const firstResult = responseData[0];

            curentInfo = {
              title: firstResult[`Title`],
              description: firstResult[`Description`],
              image: firstResult.Image,
            };

            setHjInfo({ ...curentInfo });
            const data = new Response(JSON.stringify(firstResult));

            if ("caches" in window) {
              // Opening given cache and putting our data into it
              caches.open("HJWeb").then((cache) => {
                cache.put("siteHomePage", data);
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
          setLoadingInfo(false);
        });
    } catch (error) {
      console.log("error:", error);
      setLoadingInfo(false);
    }

    try {
      let homedata = [];
      if ("caches" in window) {
        var curl = lang + "/api/home/home";

        // Opening that particular cache
        const cacheStorage = await caches.open("HJWeb");
        // Fetching that particular cache data
        const cachedResponse = await cacheStorage.match(curl);
        homedata = await cachedResponse?.json();
      }

      if (homedata && homedata.length > 0) {
        setBrands(homedata);
      } else {
        // axios.request({
        //     baseURL: config.controllURL,
        //     url: lang + "/api/home/home",
        //     method: "get",
        // })
        homeService
          .fetchHome()
          .then((response) => {
            try {
              // setHome(response.data.home);
              setBrands(response.data.brands);

              if ("caches" in window) {
                // Opening given cache and putting our data into it
                caches.open("HJWeb").then((cache) => {
                  cache.put(lang + "/api/home/home", new Response(JSON.stringify(response.data.brands)));
                });
              }
            } catch (error) { }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } catch (error) { }

    try {
      if ("caches" in window) {
        let url = "vehicles-" + lang;

        // Opening that particular cache
        const cacheStorage = await caches.open("HJWeb");
        console.log("vcacheStorage", cacheStorage);
        // Fetching that particular cache data
        const cachedResponse = await cacheStorage.match(url);
        let data = await cachedResponse?.json();
        console.log("data", data);
        setCars(data.data.vehicles);
      }
    } catch (error) { }

    // axios.request({
    //     baseURL: config.controllURL,
    //     url: lang + "/api/home/vehicles",
    //     method: "get",
    // })
    vehicleService
      .fetchHomeVehicles()
      .then((response) => {
        setCars(response?.data?.vehicles);
        const data = new Response(JSON.stringify(response));

        if ("caches" in window) {
          // Opening given cache and putting our data into it
          caches.open("HJWeb").then((cache) => {
            cache.put("vehicles-" + lang, data);
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // await axios.request({
    //     baseURL: config.controllURL,
    //     url: lang + "/api/home/HomeExtra",
    //     method: "get",
    // })
    // Backend returns offer fields in PascalCase (Title/TotalDays/Image/Slug/…)
    // but the UI (homeOfferSection.jsx, Offer component) reads camelCase keys.
    // Normalize here so the rest of the app keeps working regardless of casing.
    const normalizeOffer = (o) => o && ({
      ...o,
      id: o.id ?? o.Id,
      title: o.title ?? o.Title,
      excerpt: o.excerpt ?? o.Excerpt,
      additional: o.additional ?? o.Additional,
      terms: o.terms ?? o.Terms,
      type: o.type ?? o.Type,
      price: o.price ?? o.Price,
      totalDays: o.totalDays ?? o.TotalDays,
      slug: o.slug ?? o.Slug,
      otherLink: o.otherLink ?? o.OtherLink,
      image: o.image ?? o.Image,
      startDate: o.startDate ?? o.StartDate,
      endDate: o.endDate ?? o.EndDate,
      offerTypeId: o.offerTypeId ?? o.OfferTypeId,
    });

    homeService
      .fetchHomeExtra()
      .then((response) => {
        setOfferPart((response.data.offerPart || []).map(normalizeOffer));

        setOfferVehicle((response.data.offerVehicle || []).map(normalizeOffer));

        setOfferPartFilters(response.data.offerPartTypes);

        setOfferVehicleFilters(response.data.offerVehicleTypes);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [lang]);
  const [seoPageInfo, setSeoPageInfo] = useState({});
  useEffect(() => {
    async function fetchSeoInfo() {
      try {
        const response = await callFunc("SiteFetchSeoPages", { page: "Home" });
        if (response.status === 200 && response.data?.[0]) {
          setSeoPageInfo(response.data[0]);
        }
      } catch (e) {
        console.warn("SEO info unavailable:", e?.message);
      }
    }
    fetchSeoInfo();
  }, []);

  const [visibleRange, setVisibleRange] = useState({ start: 0, end: 2 }); // Render 4 slides at a time

  const handleSlideChange = (swiper) => {
    if (!Array.isArray(slides) || slides.length === 0) return; // defensive: slides not loaded yet
    const activeIndex = swiper.activeIndex;
    const buffer = 2; // Number of slides before and after the active one to render
    setVisibleRange({
      start: Math.max(0, activeIndex - buffer),
      end: Math.min(slides.length, activeIndex + buffer + 2) > visibleRange.end ? Math.min(slides.length, activeIndex + buffer + 2) : visibleRange.end,
    });
  };
  return (
    <Fragment>
      {seoPageInfo && (
        <Helmet>
          <meta charSet="utf-8" />
          {seoPageInfo?.title && <title>{seoPageInfo?.title}</title>}
          {seoPageInfo?.link && <link rel="canonical" href={seoPageInfo?.link} />}
          {seoPageInfo?.MetaDescription && <meta name="description" content={seoPageInfo?.MetaDescription} />}
          {seoPageInfo?.MetaGroups && <meta name="keywords" content={seoPageInfo?.MetaGroups} />}
        </Helmet>
      )}

      <div className="home-v7-wrapper">
        <div>
          {isLoadingslides ? (
            <>
              <Skeleton count={1} borderRadius={"0"} width={"100%"} height={"100vh"} containerClassName={""} className={"slide-container main-slider w-full"} inline={true} />
            </>
          ) : (
            <Swiper
              onSlideChange={handleSlideChange}
              className={"slide-container main-slider"}
              spaceBetween={0}
              slidesPerView={1}
              navigation={true}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                576: {
                  effect: "fade",
                },
              }}
              effect="fade"
              watchSlidesVisibility
              watchSlidesProgress
              loop={true}
              observer={true}
              resizeObserver={true}
              onUpdateSlider={(slide) => {
                slide.update();
              }}>
              {slides?.map((slide, index) => {
                // Render only slides within the visible range
                if (index >= visibleRange.start && index < visibleRange.end) {
                  return (
                    <SwiperSlide key={slide.slug + "_" + index}>
                      <Slide
                        key={slide.slug + "_" + index}
                        type={slide.type}
                        seats={slide.seatsNumber}
                        year={slide.year}
                        hybridImage={slide.hybridImage}
                        id={slide.siteId}
                        img={slide.image}
                        bg={slide.background}
                        name={slide.name}
                        cylinders={slide.cylinders}
                        petrol={slide.petrol}
                        colorID={slide.colorID}
                        HP={slide.hp}
                        brand={slide.brand}
                        brandID={slide.brandID}
                        otherBrand={slide.otherBrand}
                        group={slide.group}
                        slug={slide.slug}
                        minPrice={slide.minPrice}
                        ProductId={slide.productId}
                        RateCareDiscount={slide.rateCareDiscount}
                        Tax={slide.rateTaxCar}
                        modelTypes={slide.modelTypes}
                        end_Offer={slide.end_at}
                        NewCar_DateEnd={slide.newCar_DateEnd}
                        NewCar={slide.newCar}
                        Hybird={slide.hybird}
                        showPric={slide.showPric}
                        viewSliderIcon={slide.viewSliderIcon}
                        viewSliderDetails={slide.viewSliderDetails}
                        viewBtns={slide.viewBtns}
                        sliderBackOpasity={slide.sliderBackOpasity}
                      />
                    </SwiperSlide>
                  );
                } else {
                  return <SwiperSlide key={slide.slug + "_" + index}> </SwiperSlide>;
                }
              })}
            </Swiper>
          )}
        </div>
        <HomeSearch />
        {/* <OfferAdsSection /> */}

        {/* <div className="container mb-32 mt-32">


                    <video width="750" height="500" controls >
                        <source src="https://hassanjameel.com.sa/app/uploads/2020/12/2021-Lexus-LC-Convertible-Luxury-Coupe.mp4" type="video/mp4" />
                    </video>
                </div> */}

    

        <ServicesSection trans={trans} onMaintenanceClick={handleServiceOrder} />


        <WhyHJSection />

        {cars && <HomeVehicleSection cars={cars} brands={brands} />}

        <AdsBanner />

        {/*----------------------Start offers sections------------------*/}
        {offerPart?.length > 0 && <HomeOfferSection offers={offerPart} filters={offerPartFilters} type={"offer-parts"} link={""} />}
        {offerVehicle?.length > 0 && <HomeOfferSection offers={offerVehicle} filters={offerVehicleFilters} type={"offer-vehicles"} link={""} />}
        {/*----------------------End offers sections------------------*/}

        <div className="container mb-12 mt-12">
          {isLoadingInfo ? (
            <>
              <Skeleton count={1} borderRadius={"1rem"} width={"100%"} height={"30rem"} containerClassName={""} className={""} inline={true} />
            </>
          ) : (
            hjInfo && <Info hjData={hjInfo} />
          )}
        </div>

        <TestimonialSection />

        {aboutData && Object.keys(aboutData).length > 0 && (
          <CounterSection about={aboutData} />
        )}
      </div>
    </Fragment>

  );
}
